module.exports = __webpack_public_path__ + "0a704c9718f649871c0469eb60419fa6.svg";